import { makeStyles } from '@material-ui/core';
import { aliceBlue, carouselPink, oldLace } from '../../../abstracts/colours';
import { sourceSansPro } from '../../../abstracts/constants';

const useStyles = makeStyles({
  root: {
    overflow: 'hidden',
  },
  primary: {
    backgroundColor: aliceBlue,
  },
  secondary: {
    backgroundColor: oldLace,
  },
  tertiary: {
    backgroundColor: carouselPink,
  },
  content: {
    padding: '16px 32px 16px 40px',
    fontSize: '16px',
    letterSpacing: '0.13px',
    fontFamily: sourceSansPro,
  },
});

export default useStyles;
